import Mustache from "mustache";
import { MenuItem } from 'instantsearch.js/es/connectors/menu/connectMenu';
import Search, { ViewFilterType, SearchInitConfig, SearchClientConfig } from "../search";
import Utility from '../../classes/utility';
import AwardsCustomRender from '../customRenders/awards-render'
import TextFilters, { TextFilterTypes } from "../utilities/text-filters";

// awards templates
const searchParentTemplate = require('/src/templates/components/search/awards/search-parent-tpl').default;
const itemParentTemplate = require('/src/templates/components/search/awards/item-parent-tpl').default;
const itemTemplateList = require('/src/templates/components/search/awards/item-tpl--list').default;
const itemEmptyTemplate = require('/src/templates/components/search/awards/item-empty-tpl').default;

class AwardsSearch extends Search {
    private landingSearchElement: HTMLElement;
    private landingSearchResults: HTMLElement;
    private landingSearchBox: HTMLElement;
    
    constructor(landingSearchElement: HTMLElement, clientConfig: SearchClientConfig, initConfig: SearchInitConfig) {
        super(clientConfig, initConfig);
        this.landingSearchElement = landingSearchElement;
        this.index.setSettings({
            customRanking: ['asc(title)']}).then(() => {});
        this.landingSearchResults = document.querySelector(`.${landingSearchElement.dataset.id}-results`);
        this.renderParent();
        this.initConfigOverride();
    }

    private initConfigOverride() {
        this.initConfig = {
            searchBoxId: this.landingSearchBox.id,
            resultContainerId: "landing-search-hits",
            queryName: "aq",
            allowEmptyQuery: true,
            showOnLoad: true,
            activeTemplate: "list",
            textboxPlaceholder: "Search by program or award name",
            templates: {
                list: itemTemplateList,
                empty: itemEmptyTemplate
            },
            customRender: AwardsCustomRender.customRender
        };
    }

    private renderParent() {
        let self = this;
        self.landingSearchElement.innerHTML = Mustache.render(searchParentTemplate, {
            id: self.landingSearchElement.dataset.id
        });
        self.landingSearchResults.innerHTML = Mustache.render(itemParentTemplate, {
            id: self.landingSearchElement.dataset.id
        });
        self.landingSearchBox = self.landingSearchElement.querySelector(".landing-search-box");
    }

    private onLoadFacets(facets: Array<any>) {
        let self = this;
        facets.forEach(facet => {
            self.addFacet({
                field: facet.key,
                value: facet.value,
            });
        });
    }

    private onLoadViewFilters() {
        let self = this;
        self.addViewFilter({
            filterType: ViewFilterType.Clear,
            elementId: `${self.landingSearchElement.dataset.id}-clearFilters`,
            cssClasses: {
                button: "btn btn-link text-white text-decoration-none clear-filters"
            }
        });
        self.addViewFilter({
            elementId: `awardTypes`,
            urlParam: "awardTypes",
            cssClasses: {
                select: "form-control color-cool-dark-grey"
            }
        });
        self.addViewFilter({
            elementId: `semesters`,
            urlParam: "semesters",
            cssClasses: {
                select: "form-control color-cool-dark-grey"
            },
            modFn: function(item: MenuItem)
            {
                item.label = item.label.replace(/([a-zA-Z])([A-Z])([a-z])/g, '$1 $2$3');
                return item;
            }
        });

        self.addViewFilter({
            elementId: `schools`,
            urlParam: "schools",
            cssClasses: {
                select: "form-control color-cool-dark-grey"
            },
            modFn: (item: MenuItem) => {
                if (item.label == "macphail") {
                    item.label = "MacPhail";
                } else {
                    item.label = item.label.replace(/([a-zA-Z])([A-Z])([a-z])/g, '$1 $2$3'); 
                }
                return item;
            }
        });
    }

    private onLoadSearch() {
        let self = this;
        // get the algolia search box
        if (self.landingSearchBox) {
            // init algolia
            self.init();
        }
    }

    private onLoadViewUpdates() {
        let self = this;

        self.customSearch = function () {
            let clearFiltersBtn = document.getElementById(`${self.landingSearchElement.dataset.id}-clearFilters`) as HTMLDivElement;

            if (clearFiltersBtn) {
                // display clear filters text
                clearFiltersBtn.classList.remove("d-none");
                clearFiltersBtn.classList.add("d-inline-block");
            } else {
                clearFiltersBtn.classList.add("d-none");
                clearFiltersBtn.classList.remove("d-inline-block");
                self.setSearchBoxValue("");
            }
        }
    }

    private onLoadtextFilters() {
        let self = this;
        let rc = document.getElementById(this.initConfig.resultContainerId).querySelector("ul");
    }

    // onloadGetParameters() {
    //     const self = this;
    //     let urlSearchParams = new URLSearchParams(window.location.search);
    //
    //     if (urlSearchParams) {
    //         let awardTypes = urlSearchParams.get('awardTypes');
    //         if (awardTypes) {
    //             self.filterOptions("awardTypes", awardTypes);
    //         }
    //
    //         let semesters = urlSearchParams.get('semesters');
    //         if (semesters) {
    //             self.filterOptions("semesters", semesters);
    //         }
    //
    //         let schools = urlSearchParams.get('schools');
    //         if (schools) {
    //             self.filterOptions("schools", schools);
    //         }
    //     }
    // }

    override onLoad(facets: Array<any>) {
        this.onLoadFacets(facets);
        this.onLoadViewFilters();
        this.onLoadSearch();
        this.onLoadViewUpdates();
        this.onLoadtextFilters();
    }

    init() {
        super.init();
        // get query in URL - if set
        let query = Utility.getUrlParameter(this.initConfig.queryName);
        //this.onloadGetParameters();
        // trigger search on page load query
        if (query) {
            this.search.helper.setQuery(query);
            this.search.helper.search();
        }
    }
}
export default AwardsSearch;